module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-edit-xs-959a8daa661416b71c600e8f2cc7ad7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-edit-xs.jpg
// module id = 346
// module chunks = 2